// HOME FORM
$(function(){
  $('.blog-email-signup-form .form__field input').on('focus', function(){
	$(this).closest('.form__row').find('.form__label').css('z-index','-1');
  });

  $('.blog-email-signup-form .form__field input').on('focusout', function(){
	  var hasVal =  $(this).val();
	  if(hasVal == ''){
		  $(this).closest('.form__row').find('.form__label').css('z-index','1');
	  }
  });
});

$(function(){
  // FORM LABELS
  $('.form-trigger').click(function(e){
	  e.preventDefault();
	$('.blog-email-signup-form .box-narrow').addClass('active');
  });
});

$(function(){
  //active mobile nav
  $('.hamburger').click(function(){
    $(this).toggleClass('active');
  });
});

$(function(){
  //active mobile nav
  $('.js-toggle-lang').click(function(){
    $('.js-toggle-lang-list').toggle();
  });
});


//FAQ ACCORDION TOGGLE
$('.toggle').click(function(e) {
  	e.preventDefault();
    var $this = $(this);

    if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
		$this.removeClass('active');
        $this.next().slideUp(350);
    } else {
        $this.parent().parent().find('li .inner').removeClass('show');
		$this.parent().parent().find('li .toggle').removeClass('active');
        $this.parent().parent().find('li .inner').slideUp(350);
        $this.next().toggleClass('show');
		$this.toggleClass('active');
        $this.next().slideToggle(350);
    }
});

if(window.location.hash) {
 // Fragment exists
var hash = decodeURI(window.location.hash);
$('li' + hash + ' ul').addClass('show').slideToggle(350);
}

function modal($modalContent, $showButton)
{
	$buttonText = 'OK';
	if($showButton!=true)
	{
		$buttonText = $showButton;
	}
	$button = '<a class="btn js-modal-close button" href="#!">' + $buttonText + '</a>',

	$modal = '<div class="modal-cover"></div><div class="modal"><div class="modal-content"><a href="#" class="modal-close js-modal-close">&times;</a>' + $modalContent + '</div></div>';

	if ($showButton) {
		$modal = '<div class="modal-cover"></div><div class="modal"><div class="modal-content"><a href="#" class="modal-close js-modal-close">&times;</a>' + $modalContent + $button + '</div></div>';
	}

	$('body').addClass('modal-open').append($modal).find('.js-modal-close, .modal-cover').on('click',function(e){
		e.preventDefault();
		$('.modal, .modal-cover').fadeOut(150,function(){
			$('.modal, .modal-cover').remove();
			$('body').removeClass('modal-open');
		})
	});

	return false;
}


(function($) {

	$('.js-nav').on('click', function(){
		$('nav').stop().slideToggle();
	});

	$('.js-bg').each(function(){
		var src = $(this).find('.js-bg-img').attr('src');

		$(this).css({'background' : 'url(' + src + ') center / cover no-repeat'});
	});

	$('.js-tabs li').on('click', function(){
		var $this = $(this),
		tab = $this.data('tab');

		if (!$this.hasClass('active')) {
			$('.js-tabs li').removeClass('active');
			$('.js-tab:visible').fadeOut(150,function(){
				$this.addClass('active');
				$('.js-tab[data-tab="' + tab + '"]').fadeIn(150);
			});
		}
	});

	$('.js-modal-trigger').on('click', function(){
		var $this = $(this),
		title = $this.html(),
		contentArea = $this.data('modal-content'),
		content = $('div[data-modal-content="' + contentArea + '"]').html();

		modal('<h4>' + title + '</h4>'+ content);
	});


	if ($('.js-parallax').length) {
		$('.js-parallax').parallax();

		$('.js-parallax .hex-content').each(function(){
			var $this = $(this),
			delay = Math.floor(Math.random() * (4000)) + 2000;
			// The timout will never be over 6000ms  or below
			// 2000ms using the following function
			// Math.floor(Math.random() * (max - min)) + min
			// 6000 = maximum time
			// 2000 = minimum time
			// 4000 = maximum time - minimum time

			$this.cycle({
				timeout: delay
			});
		})
	}


	if ($('.js-slider').length) {
		if ($(window).width() >= "768") {
			$('.js-slider').slick({
				arrows: false,
				autoplay: true,
				autoplaySpeed: 4000,
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1
			});

			$('.js-slider-prev').on('click', function(){
				$('.js-slider').slick('slickPrev');
			});

			$('.js-slider-next').on('click', function(){
				$('.js-slider').slick('slickNext');
			});
		}
	}

	if ($('.js-timeline').length) {
		$('.js-timeline').slick({
			arrows: false,
			asNavFor: '.js-timeline-steps',
			centerMode: true,
			centerPadding: '0',
			focusOnSelect: true
		});

		$('.js-timeline-steps').slick({
			arrows: false,
			asNavFor: '.js-timeline',
			centerMode: true,
			centerPadding: '0',
			slidesToShow: 5,
			slidesToScroll: 1,
			focusOnSelect: true,
			responsive: [{
				breakpoint: 1500,
				settings: {
					slidesToShow: 5
				}
			}, {
				breakpoint: 1280,
				settings: {
					slidesToShow: 5
				}
			}, {
				breakpoint: 992,
				settings: {
					slidesToShow: 3
				}
			}, {
				breakpoint: 768,
				settings: {
					slidesToShow: 3
				}
			}, {
				breakpoint: 568,
				settings: {
					slidesToShow: 1
				}
			}]
		});

		$('.js-timeline-prev').on('click', function(){
			$('.js-timeline').slick('slickPrev');
		});

		$('.js-timeline-next').on('click', function(){
			$('.js-timeline').slick('slickNext');
		});
	}

	$('.js-ajax-people').on('click', function(){
		var $this = $(this),
		base = '/ajax/people/',
		page = $this.data('page');

		if (!$this.hasClass('js-disabled')) {
			$this.addClass('js-disabled');

			$.ajax({
				url: base + page
			}).done(function(html) {
				var currentPage = page.split('p')[1],
				newPage = parseInt(currentPage) + 1,
				newColumns = $(html).filter('.columns').find('.column').css({'opacity': '0'});

				$('.js-ajax-target').append(newColumns);

				$('.js-ajax-target .column').each(function(){
					var $this = $(this);

					$this.animate({'opacity': '1'}, 250);
				});

				if (newColumns.length == '100') {
					$this.data('page', 'p' + newPage).removeClass('js-disabled');
				} else {
					$this.parent().fadeOut();
				}


			});
		}

	});

	if ($('.js-accordion').length) {
		$(window).on('load resize', function(){
			if ($('.js-accordion').is(':visible')) {
				$('.js-accordion:not(:first-of-type)').next().slideUp();

				$('.js-accordion').on('click', function(){
					if ($(this).next().is(':hidden')) {
						$('.js-accordion').next().slideUp();
						$(this).next().slideDown();
					}
				});
			} else {
				$('.js-accordion').next().slideDown();
			}
		});
	}

	if ($('.js-circle-hover').length) {
		$('.js-circle-tooltip').on({mouseenter: function(e){
			var $this = $(this),
			tooltip = $this.find('desc').html(),
			tipContainer = $('<div class="tip-container js-tip-container"></div>'),
			tipContent = tipContainer.html(tooltip)
			posX = $this.offset().left,
			posY = $this.offset().top;

			if (!$('.js-tip-container').length) {
				$('body').append(tipContent);
				var tcH = $('.js-tip-container').height(),
				tcW = $('.js-tip-container').width();

				$('.js-tip-container').css({'top': posY - (tcH*1.5), 'left': posX});
			}

		}, mouseleave: function(){
			if ($('.js-tip-container').length) {
				$('.js-tip-container').remove();
			}
		}});
	}

	$('.js-ajax-category').on('click', function(){
		var $this = $(this),
		base = '/ajax/customers',
		page = $this.data('cat'),
		url;

		if (page) {
			url = base + '?cat=' + page;
		} else {
			url = base;
		}

		if ($this.hasClass('button-secondary-outline')) {
			$('.js-ajax-category').removeClass('button-secondary');
			$this.addClass('button-secondary');

			$.ajax({
				url: url
			}).done(function(html) {
				var newCustomers = $(html).filter('.js-ajax-customers').find('.columns').css({'opacity': '0'});

				$('.js-ajax-target .columns').animate({'opacity': '0'}, 250).remove();

				$('.js-ajax-target').append(newCustomers);

				$('.js-ajax-target .columns').each(function(){
					var $this = $(this);

					$this.animate({'opacity': '1'}, 250);
				});
			});
		}

	});

	if ($('.js-circle-animate').length || $('.js-icon-list').length) {

		$(window).on('load', function(){
			var windowH = $(window).height(),
			bodyH = $('body').height(),
			starPos = $('.js-star-container').offset().top,
			listPos = $('.js-icon-list').offset().top,
			listAnimTrigger = listPos - (windowH/1.5),
			circlePos,
			circleAnimTrigger;

			if ($('.js-circle-animate').length) {
				circlePos = $('.js-circle-animate').offset().top,
				circleAnimTrigger = circlePos - (windowH/1.5);
			}


			$('.js-stars li').each(function(i,el) {
				var $this = $(this);
				setTimeout(function() {
					$this.addClass('loading');
				}, i*250);
			});

			$(window).on('scroll', function(){
				var scrollPos = $(this).scrollTop();


				if (scrollPos > 1) {
					$('.js-stars li').each(function(i,el) {
						var $this = $(this);
						setTimeout(function() {
							$this.addClass('active');
						}, i*250);
					});
				}

				if (scrollPos > listAnimTrigger) {
					$('.js-icon-list li').each(function(i,el) {
						var $this = $(this);
						setTimeout(function() {
							$this.addClass('visible');
						}, i*500);
					});
				}

				if (scrollPos > circleAnimTrigger) {

					$('.js-circle-sector').each(function(i){
						var $this = $(this);
						setTimeout(function() {
							if ($this.is('g')) {
								$this[0].classList.add('circle-sector-animated');
							} else {
								$this.addClass('circle-sector-animated');
							}
						}, i*500);
					});

					setTimeout(function() {
						$('.js-circle-centre').each(function(i){
							var $this = $(this);
							if ($this.is('g')) {
								$this[0].classList.add('circle-centre-animated');
							} else {
								$this.addClass('circle-centre-animated');
							}
						});
					}, 4*500);


				}
			});
		});
	}

	$(window).on('load', function(){
		$('.js-anim-trigger').each(function(){
			var $this = $(this),
			animPos = $this.offset().top,
			animTrigger = animPos - ($(window).height()/3);

			if ($this.hasClass('js-anim-onload')) {
				$this.find('.js-animate').each(function(i,el) {
					var $this = $(this);
					setTimeout(function() {
						if ($this.is('svg')) {
							$this[0].classList.add('animated');
						} else {
							$this.addClass('animated');
						}
					}, i*250);
				});
			} else {
				$(window).on('scroll', function(){
					var scrollPos = $(this).scrollTop();


					if (scrollPos > animTrigger) {
						$this.find('.js-animate').each(function(i,el) {
							var $this = $(this);
							setTimeout(function() {
								if ($this.is('svg')) {
									$this[0].classList.add('animated');
								} else {
									$this.addClass('animated');
								}
							}, i*250);
						});
					}
				});
			}

		});

		$('.js-scroll').on('click', function(){
			var scrollPos = $('.js-anim-trigger:nth-child(1)').offset().top;

			$('html, body').animate({scrollTop: scrollPos}, 500);
		});


		$('.js-popup').on('click', function(e){
			e.preventDefault();
			var href = $(this).attr('href');
			window.open(href, 'hgem', "height=600,width=800")
			return false;
		});

		// set a language cookie to allow switching between languages when auto-detection is turned on
		$('.js-lang').on('click', function(e){
			var lang = $(this).data('lang');
			Cookies.set('locale', lang, { expires: 365 });
		});
	});

	$(document).on("ready", function() {
		$(".home .hero").addClass("slide-up");
	});

	$('.js-cookie-dismiss').on('click', function(){
		$.cookie('HGem_Cookie', 'true', { expires: 28 });
		$('.js-cookie-bar').slideUp();
	})

	if (!$.cookie('HGem_Cookie')) {
		$('.js-cookie-bar').slideDown();
	}
})(jQuery);
